import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "regenerator-runtime/runtime.js";
import dsteem from "../unit/DsteemUtil";
import { extractLoginData, getAccount } from "../unit/UserUtil";
import PostCard from "../components/PostComponents/PostCard.vue";
import CommunityEasyCard from "../components/CommunityComponents/CommunityEasyCard.vue";
import { $t } from "../plugins/i18n";
export default {
  components: {
    PostCard: PostCard,
    CommunityEasyCard: CommunityEasyCard
  },
  data: function data() {
    return {
      loginData: null,
      selectPost: "trending",
      selectPostOption: [{
        key: "Trending",
        value: "trending"
      }, {
        key: "Payouts",
        value: "payout"
      }],
      blogs: [],
      communities: [],
      name: ""
    };
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loginData = extractLoginData();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onRefresh: function onRefresh(done) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dsteem.getBlogsByBridge(_this2.name ? _this2.name : _this2.loginData ? _this2.loginData[0] : null, _this2.selectPost.toLowerCase(), "my", 20);

              case 2:
                _this2.blogs = _context2.sent;
                done();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onLoad: function onLoad(done) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var permlink, author, nextblogs;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                permlink = _this3.blogs[_this3.blogs.length - 1].permlink;
                author = _this3.blogs[_this3.blogs.length - 1].author;
                _context3.next = 4;
                return dsteem.getBlogsByBridge(_this3.name ? _this3.name : _this3.loginData ? _this3.loginData[0] : null, _this3.selectPost.toLowerCase(), "my", 20, permlink, author);

              case 4:
                nextblogs = _context3.sent;
                nextblogs.shift();

                _this3.blogs.push.apply(_this3.blogs, nextblogs);

                done();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  watch: {
    selectPost: function selectPost() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return dsteem.getBlogsByBridge(_this4.name ? _this4.name : _this4.loginData ? _this4.loginData[0] : null, _this4.selectPost.toLowerCase(), "my", 20);

              case 2:
                _this4.blogs = _context4.sent;

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _this5$$route$params, _this5$$route$params$;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.loadAccount();

            case 2:
              _this5.name = (_this5$$route$params = _this5.$route.params) === null || _this5$$route$params === void 0 ? void 0 : (_this5$$route$params$ = _this5$$route$params.username) === null || _this5$$route$params$ === void 0 ? void 0 : _this5$$route$params$.replace("@", ""); //console.log(this.name);

              _context5.next = 5;
              return dsteem.getAccountSubscriptionsByBridge(_this5.name ? _this5.name : _this5.loginData ? _this5.loginData[0] : null);

            case 5:
              _this5.communities = _context5.sent;
              _context5.next = 8;
              return dsteem.getBlogsByBridge(_this5.name ? _this5.name : _this5.loginData ? _this5.loginData[0] : null, _this5.selectPost.toLowerCase(), "my", 20);

            case 8:
              _this5.blogs = _context5.sent;

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
};